<template>
	<div class="service" v-loading="loading">
        <div class="banners">
            <img src="../../../assets/img/index/services/banner.png" alt="">
        </div>
        <div class="service_box">
            <div class="type_list">
                <div class="type_item" v-for="(item,index) in type_list" :key="index" :class="{type_ac:item.type==type_ac}" @click="handle_type(item)">
                    <div class="items">
                        <div class="item_img">
                            <img :src="item.imgs" alt="">
                        </div>
                        <div class="item_info">
                            <div class="item_title">{{ item.title }}</div>
                            <div class="item_text">{{ item.text }}</div>
                        </div>
                    </div>
                    <div class="type_borders" v-if="index<2"></div>
                </div>
            </div>
            <div class="type_box" v-if="type_ac==1">
                <div class="type_lefts">
                    <div class="left_title">填写信息</div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>费用类型</div>
                        <div class="form_input1">
                            <el-select v-model="form.title" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>案件类型</div>
                        <div class="form_input1">
                            <el-select v-model="form.title" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>财产涉及</div>
                        <div class="form_input1">
                            <el-select v-model="form.title" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>诉讼标的</div>
                        <div class="form_input2">
                            <el-input v-model="form.title" placeholder="请填写的数量">
                                <div slot="suffix">元</div>
                            </el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"></div>
                        <div class="form_input3">
                            <div class="btns1">马上计算</div>
                            <div class="btns2">重新计算</div>
                        </div>
                    </div>
                </div>
                <div class="type_border"></div>
                <div class="type_rights">
                    <div class="price_title">计算结果</div>
                    <div class="price_box1">
                        <span class="span1">0</span>
                        <span class="span2">元</span>
                    </div>
                    <div class="price_box2">
                        <div class="text1">服务类型</div>
                        <div class="text2">民事行政诉讼</div>
                    </div>
                    <div class="price_box3">
                        <div class="text1">计算方式</div>
                        <div class="text2">
                            依据
                            <span>
                                《中华人民共和国国务院令》
                            </span>
                            计算
                        </div>
                    </div>
                    <div class="price_box4">
                        温馨提示：预估价格仅供参考<span>《计算标准说明》</span>
                    </div>
                </div>
            </div>
            <div class="type_box" v-if="type_ac==2">
                <div class="type_lefts">
                    <div class="left_title">填写信息</div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>服务类型</div>
                        <div class="form_input1">
                            <el-select v-model="form.title" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>服务事项</div>
                        <div class="form_input1">
                            <el-select v-model="form.title" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"><span>*</span>诉讼标的</div>
                        <div class="form_input2">
                            <el-input v-model="form.title" placeholder="请填写的数量">
                                <div slot="suffix">元</div>
                            </el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title"></div>
                        <div class="form_input3">
                            <div class="btns1">马上计算</div>
                            <div class="btns2">重新计算</div>
                        </div>
                    </div>
                </div>
                <div class="type_border"></div>
                <div class="type_rights">
                    <div class="price_title">计算结果</div>
                    <div class="price_box1">
                        <span class="span1">0</span>
                        <span class="span2">元</span>
                    </div>
                    <div class="price_box2">
                        <div class="text1">服务类型</div>
                        <div class="text2">民事行政诉讼</div>
                    </div>
                    <div class="price_box3">
                        <div class="text1">计算方式</div>
                        <div class="text2">
                            依据
                            <span>
                                《中华人民共和国国务院令》
                            </span>
                            计算
                        </div>
                    </div>
                    <div class="price_box4">
                        温馨提示：预估价格仅供参考<span>《计算标准说明》</span>
                    </div>
                </div>
            </div>
            <div class="type_box2"  v-if="type_ac==3">
                <table border class="type_table">
                    <tr class="type_header">
                        <td class="td1">服务项目</td>
                        <td class="td2">费用</td>
                    </tr>
                    <tr class="table_list" v-for="(item,index) in fwfy_list" :key="index" :class="{table_list_color:(index+1)%2==0}">
                        <td>{{ item.title }}</td>
                        <td>{{ item.price }}</td>
                    </tr>
                </table>
            </div>
            <div class="ls_box">
                <div class="title_box">
                   <div class="text_box">
                        <div class="title_text1">精英律师</div>
                        <div class="title_text2">
                            ELITE LAWYER
                            <img src="@/assets/img/index/home/right1.png" alt="">
                        </div>
                   </div>
                   <div class="title_btns">
                        <div class="btns">了解更多+</div>
                   </div>
                </div>
                <div class="ls_list">
                    <div class="item" v-for="(item, index) in vuex_lawyers" :key="index" v-if="index<3" @click="handle_ls_path(item)">
                        <div class="item_left">
                            <div class="item_left_tops">
                                <div class="item_title">{{ item.name }}</div>
                                <div class="item_firm">{{item.work_company}}</div>
                                <div class="item_tage">{{ minx_get_causeIds(item.causeIds) }}</div>
                            </div>
                            <div class="item_left_boms">
                                <div class="btns1">立即咨询</div>
                            </div>
                        </div>
                        <div class="item_right">
                            <!-- <img src="../../../assets/img/index/home/lsimg.png" alt=""> -->
                             <img :src="item.business_img" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tjfw_box">
                <div class="title_box">
                   <div class="text_box">
                        <div class="title_text1">推荐服务</div>
                        <div class="title_text2">
                            RECOMMENDED SERVICES
                            <img src="@/assets/img/index/home/right1.png" alt="">
                        </div>
                   </div>
                   <div class="title_btns">
                        <div class="btns">了解更多+</div>
                   </div>
                </div>
                <div class="tjfw_list">
                    <div class="item" v-for="(item,index) in list" :key="index" @click="handle_sever_path(item)">
                        <div class="item_img">
                            <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                             <img :src="item.thumb" alt="">
                        </div>
                        <div class="item_info">
                            <div class="item_title">{{ item.title }}</div>
                            <div class="item_tages">
                                <div class="tages" v-if="item.cate1">{{ item.cate1.title }}</div>
                                <div class="tages" v-if="item.cate2">{{ item.cate1.title }}</div>
                                <div class="tages" v-if="item.cate3">{{ item.cate1.title }}</div>
                            </div>
                            <div class="item_price">
                                <div class="prices"> ￥{{ item.price }}</div>
                                <div class="nums">销量 {{ item.sale_num }}</div>
                            </div>
                        </div>
                       
                    </div>
                    <div class="item2" v-for="(item,index) in 4" ></div>
                </div>
            </div>
        </div>
        <pop ref="pop"></pop>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
    import pop from '@/components/More_services/pop.vue'//提交评论

    
	export default {
		components: {
            pop
		},
		name: "index",
		data() {
			return {
				loading:false,
                type_ac:3,
                type_list:[
                    {
                        imgs:require('../../../assets/img/index/services/icon1.png'),
                        title:'诉讼费计算器',
                        text:'文案简短描述',
                        type:1,
                    },
                    {
                        imgs:require('../../../assets/img/index/services/icon2.png'),
                        title:'服务报价计算器',
                        text:'文案简短描述',
                        type:2,
                    },
                    {
                        imgs:require('../../../assets/img/index/services/icon3.png'),
                        title:'点评服务费',
                        text:'文案简短描述',
                        type:3,
                    },
                ],
                form:{
                    title:'',
                },
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                },],
                list:[],
                 
			}
		},
		computed: {
			...mapState(['vuex_lawyers', 'vuex_setting']),
            fwfy_list(){
                let list=[
                    {
                        title:'初级点评服务费',
                        price:this.vuex_setting.level1,
                    },
                    {
                        title:'中级点评服务费',
                        price:this.vuex_setting.level2,
                    },
                    {
                        title:'高级点评服务费',
                        price:this.vuex_setting.level3,
                    },{
                        title:'特级点评服务费',
                        // price:this.vuex_setting.level4,
                        price:'面议',

                    }
                ]

                return list
            },
		},
		watch: {
            $route: {
				handler(newVal, oldVal) {
					// this.get_user()
					this.type_ac=this.$route.query.type

				},
				immediate: true,
				deep: true
			},
		},
		created() {
            this.get_sever()
			 
		},
		methods: {
            handle_type(item){
                this.type_ac=item.type
            },
            get_sever(){
                this.$api("servePros", {
                    limit:4,
                }, "get").then((res) => {
                    this.loading = false
                    console.log('服务列表',res)
                    if (res.code == 1) {
                        this.list=res.data.data
                    } else {
                        alertErr(res.msg)
                    }
                });
                
            },
            handle_ls_path(item){
                this.$router.push({
                    path:'/lawyer_detial',
                    query:{
                        id:item.id
                    }
                })
            },
            handle_sever_path(item){
                if(item.type==1){
                    this.$router.push({
                        path:'/individual_detial',
                        query:{
                            id:item.id
                        }
                    })
                }else{
                    this.$router.push({
                        path:'/enterprise_detial',
                        query:{
                            id:item.id
                        }
                    })
                }
            },

		},

	}
</script>
<style scoped lang="less">
	.service {
        width: 100%;
        background-color: #fff;
        padding-bottom: 100px;
        .banners{
            position: relative;
            z-index: 1;
            width: 100%;
            height: 320px;
            img{
                width: 100%;
                height: 320px;
            }
        }
        .service_box{
            width: 1440px;
            margin: auto;
            position: relative;
            z-index: 2;
            .type_list{
                width: 1372px;
                height: 180px;
                background: #FFFFFF;
                box-shadow: 2px 2px 10px 1px rgba(1,9,46,0.1);
                border-radius: 8px 8px 8px 8px;
                // border-radius: 20px;
                overflow: hidden;
                margin: auto;
                margin-top: -90px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .type_item{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    .items{
                        width: 457px;
                        height: 180px;
                        // background-color: red;
                        border-bottom:6px solid #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .item_img{
                            width: 48px;
                            img{
                                width: 48px;
                            }
                        }
                        .item_info{
                            padding-left: 24px;
                            .item_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 20px;
                                color: #333333;
                            }
                            .item_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                margin-top: 12px;
                            }
                        }

                    }
                    .type_borders{
                        width: 1px;
                        height: 56px;
                        background: #D7D7D7;
                        // box-shadow: 2px 2px 10px 1px rgba(1,9,46,0.1);
                        // border-radius: 4px 4px 4px 4px;
                    }
                    &:hover{
                        .items{
                            border-bottom:6px solid #377CFD;

                        }
                    }
                }
                .type_ac{
                    .items{
                        border-bottom:6px solid #377CFD;

                    }
                }
            }
            .type_box{
                display: flex;
                // align-items: center;
                justify-content: space-between;
                margin-top: 64px;
                .type_lefts{
                    flex: 1;
                    padding-top: 16px;

                    // padding: 0 110px;
                    .left_title{
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 20px;
                        color: #333333;
                        margin-bottom: 40px;
                    }
                    .form_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 24px;
                        .form_title{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            padding-right: 24px;
                            width: 100px;
                            text-align: right;
                            span{
                                color: #FD4C5C;
                            }
                        }
                        .form_input1{
                            width: 400px;

                            /deep/.el-select{
                                width: 400px;
                            }
                        }
                        .form_input2{
                            width: 400px;
                            /deep/.el-input{
                                .el-input__inner{
                                    // padding-right: 40px
                                    // width: 360px;

                                }
                                .el-input__suffix{
                                    padding:0 5px;
                                    // width: 40px;
                                    display: flex;
                                    align-items: center;
                                }
                            }
                        }
                        .form_input3{
                            display: flex;
                            align-items: center;
                            margin-top: 56px;
                            .btns1{
                                width: 134px;
                                height: 40px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                text-align: center;
                                line-height: 40px;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;
                            }
                            .btns2{
                                width: 134px;
                                height: 40px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                text-align: center;
                                line-height: 40px;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #377CFD;
                                margin-left: 10px;
                            }

                        }
                        
                    }
                }
                .type_border{
                    width: 1px;
                    height: 440px;
                    background: #D1D9E1;
                    // box-shadow: 2px 2px 10px 1px rgba(1,9,46,0.1);
                    border-radius: 4px 4px 4px 4px;
                }
                .type_rights{
                    padding-top: 16px;
                    flex: 1;
                    .price_title{
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 20px;
                        color: #333333;
                        margin: auto;
                    }
                    .price_box1{
                        width: 490px;
                        height: 114px;
                        background: rgba(55,124,253,0.04);
                        border-radius: 4px 4px 4px 4px;
                        margin: auto;
                        margin-top: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .span1{
                          
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 40px;
                            color: #377CFD;

                        }
                        .span2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 24px;
                            color: #377CFD;
                            margin-left: 10px;
                        }
                    }
                    .price_box2{
                        width: 490px;
                        height: 40px;
                        background: rgba(55,124,253,0.04);
                        border-radius: 4px 4px 4px 4px;
                        margin: auto;
                        margin-top: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 16px;
                        .text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }
                        .text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                        }

                    }
                    .price_box3{
                        width: 490px;
                        height: 40px;
                        background: rgba(55,124,253,0.04);
                        border-radius: 4px 4px 4px 4px;
                        margin: auto;
                        margin-top: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 16px;
                        .text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }
                        .text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            span{
                               color: #377CFD; 
                               cursor: pointer;
                            }
                        }

                    }
                    .price_box4{
                        width: 490px;
                        margin: auto;
                        margin-top: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;
                        span{
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                }
            }
            .type_box2{
                width: 1200px;
                margin: auto;
                margin-top:65px;
                margin-bottom: 80px;
                .type_table{
                    border-collapse: collapse;
                    .type_header{
                        text-align: center;
                        border-color: #D7D7D7;
                        .td1{
                            width: 360px;
                            height: 48px;
                            background: #D0D8E6;
                            border-radius: 0px 0px 0px 0px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #000000;
                            border-right: 1px solid #EBEEF5;
                        }
                        .td2{
                            width: 848px;
                            height: 48px;
                            background: #D0D8E6;
                            border-radius: 0px 0px 0px 0px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #000000;
                        }
                    }
                    .table_list{
                        height: 48px;
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                        border: 0;
                    }
                    .table_list_color{
                        background: #F0F2F5;
                    }
                }
                
            }
            .ls_box{
                .title_box{
                    display: flex;
                    justify-content: space-between;
                    .text_box{
                        display: flex;
                        align-items: end;
                        .title_text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 36px;
                            color: #333333;
                        }
                        .title_text2{
                            padding-left: 16px;
                            display: flex;
                            align-items: end;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #377CFD;
                            img{
                                margin-left: 19px;
                                width: 28px;
                            }
                        }
                    }
                    .title_btns{
                        display: flex;
                        align-items: center;
                        .btns{
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;

                        }
                    }
                    
                }
                .ls_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 48px;
                   
                    .item {
                        width: 458px;
                        height: 258px;
                        flex-shrink: 0;
                        background: #FFFFFF;
                        border-radius: 8px 8px 8px 8px;
                        display: flex;
                        // align-items: center;
                        padding: 32px 0 0 24px;
                        background-image: url('../../../assets/img/index/services/bg1.png');
                        background-size: 100%;

                        .item_left {
                            width: 200px;
                            display: flex;
                            flex-wrap: wrap;
                            align-content: space-between;
                            padding-right: 20px;
                            .item_left_tops {
                                width: 200px;

                                .item_title {
                                    // width: 200px;
                                    font-weight: bold;
                                    font-size: 24px;
                                    color: #333333;
                                    word-break: break-all;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp:1;
                                    -webkit-box-orient: vertical;
                                }

                                .item_firm {
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #333333;
                                    padding-top: 10px;
                                }

                                .item_tage {
                                    padding-top: 20px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #666666;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp:2;
                                    -webkit-box-orient: vertical;
                                }
                            }

                            .item_left_boms {
                                // display: flex;
                                // align-items: center;
                                padding-bottom: 30px;

                                .btns1 {
                                    width: 180px;
                                    height: 40px;
                                    background: #377CFD;
                                    border-radius: 4px 4px 4px 4px;
                                    text-align: center;
                                    line-height: 40px;
                                    cursor: pointer;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #FFFFFF;

                                }
                            }
                        }

                        .item_right {
                            width: 224px;
                            height: 100%;
                            overflow: hidden;
                            flex-shrink: 0;

                            img {
                                width: 224px;
                            }
                        }
                    }
                }
            }
            .tjfw_box{
                padding-top: 80px;
                .title_box{
                    display: flex;
                    justify-content: space-between;
                    .text_box{
                        display: flex;
                        align-items: end;
                        .title_text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 36px;
                            color: #333333;
                        }
                        .title_text2{
                            padding-left: 16px;
                            display: flex;
                            align-items: end;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #377CFD;
                            img{
                                margin-left: 19px;
                                width: 28px;
                            }
                        }
                    }
                    .title_btns{
                        display: flex;
                        align-items: center;
                        .btns{
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;

                        }
                    }
                    
                }
                .tjfw_list{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 48px;
                    flex-wrap: wrap;
                    .item2{
                        width: 330px;
                    }
                    .item{
                        width: 330px;
                        height: 425px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid #D7D7D7;
                        .item_img{
                            width: 330px;
                            height: 260px;
                            img{
                                width: 330px;
                                height: 260px;
                            }
                        }
                        .item_info{
                            padding: 24px 20px;
                            .item_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 18px;
                                color: #333333;
                            }
                            .item_tages{
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;
                                padding-top: 16px;
                                min-height: 30px;
                                .tages{
                                    padding: 4px 12px;
                                    background: #FDF6EC;
                                    border-radius: 3px 3px 3px 3px;
                                    border: 1px solid #FFAA00;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #FFAA00;
                                    margin-right: 10px;
                                }

                            }
                            .item_price{
                                padding-top: 20px;
                                display: flex;
                                // align-items: center;
                                align-items: end;
                                justify-content: space-between;
                                .prices{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 28px;
                                    color: #FD4C5C;

                                }
                                .nums{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }
                            }

                        }
                    }
                }
            }

        }
		 

	}
</style>